export default "<app-directory></app-directory>\n";